module.exports = __webpack_public_path__ + "static/img/img_ab_banner_ys.1ef19340.png";